import { styled as i } from "styled-components";
import { ZIndex as t, MediaQuery as r } from "../../../../styles/variables.js";
import { Theme as o } from "../../../../styles/themes/index.js";
const d = i.dialog`
  position: inherit;

  &[open] {
    position: absolute;
    left: 0;
    top: 100%;
    width: 100%;
    height: calc(100vh - 100%);
    padding: 16px;
    background-color: rgba(${o.colors.Juliet}, 0.97);
    overflow: auto;
    z-index: ${t.AUTOCOMPLETE_SUGGESTION_BOX};
    margin-top: 0;

    @media ${r.SCREEN_MD_UP} {
      position: absolute;
      top: 100%;
      height: auto;
      padding: 16px;
      background-color: rgb(${o.colors.Juliet});
      border: solid 1px rgb(${o.colors.Golf});
      border-radius: 12px;
      border-top-left-radius: unset;
      border-top-right-radius: unset;
      transition: height ease 0.3s;
      padding: 24px;
      max-height: 424px;
      margin-top: 13px;
    }
  }
`;
i.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;
export {
  d as SuggestionsOverlay
};
